import { Link } from 'react-router-dom';
import { hotTopics } from '@/mocks/data';

export default function HotScrollSection() {
  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="container-page">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">
              实时热瓜 <span className="text-primary-500">滚动更新</span>
            </h2>
            <p className="text-secondary-500 text-sm mt-1">全网最热吃瓜事件实时追踪</p>
          </div>
          <Link
            to="/category/shejiao-remen"
            className="text-secondary-500 text-xs bg-background-200 px-3 py-1.5 rounded-full hover:text-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
          </Link>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-thin -mx-4 px-4 md:mx-0 md:px-0">
          {hotTopics.map((topic) => (
            <Link
              key={topic.id}
              to={`/article/${topic.articleSlug}`}
              className="flex-shrink-0 w-[260px] md:w-[280px] bg-white border border-background-200 rounded-lg overflow-hidden cursor-pointer group transition-transform hover:-translate-y-1 duration-300"
            >
              <div className="relative w-full h-[180px] md:h-[200px] overflow-hidden">
                <img
                  src={topic.image}
                  alt={topic.title}
                  title={`${topic.title} - 17吃瓜热搜`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500/90 text-foreground-50 text-xs px-2 py-0.5 rounded-full">
                    {topic.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="text-primary-500 font-bold text-lg md:text-xl">
                    {topic.heat}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-foreground-800 text-sm leading-relaxed line-clamp-2 group-hover:text-foreground-950 transition-colors">
                  {topic.title}
                </p>
              </div>
            </Link>
          ))}
          <div className="flex-shrink-0 w-[60px] md:w-[80px]"></div>
        </div>
      </div>
    </section>
  );
}